/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-undef */
import { motion } from 'framer-motion'
import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Shimmer from './Shimmer'
import EmptyPage from './EmptyPage'
import { checkPrivilege } from '../../../CommonMethods/checkPrivilege'

export default function Table({ searchParams,loading,DateRange,initialDate, error, notFound }) {
    const { List } = useSelector(state => state.Settlements)
    const navigate = useNavigate()
    const param = Object.fromEntries(searchParams);

    const convertToDate = (timestamp) => {
        // Format the date in the desired format
        return new Date(timestamp * 1000).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric',timeZone:'GMT' })
    }

    const hasViewSettlement = checkPrivilege('view_settlement')
    useEffect(() => {

    },[])

    return (
        <div className='bg-white mx-5 overflow-auto h-[calc(100vh-375px)] mt-4 scrollBar'>
            <table className="w-full pr-5 sticky top-0 left-0 bg-white"> {/* ((List?.length !== 0 && loading) || (List?.length?.data !== 0 && !loading)) */}
                { (List?.data?.length > 0 || loading)  &&
                <thead className='sticky top-0 bg-white z-[9]'>
                    <tr className="border-b-[1px] border-[#EEEEEE]">
                        <th className="px-4 py-3 text-left sticky left-0 top-0 min-w-[170px] bg-[#FAFAFA]">
                            <span className="text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]">
                                Settlement Cycle ID
                            </span>
                        </th>
                        <th className='px-4 py-3 text-left min-w-[140px] bg-[#FAFAFA]'>
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Merchant Name
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[110px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Store Name
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[140px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Cycle Start Date
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[140px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Cycle End Date
                            </span>
                        </th>
                        <th className="px-4 py-3 text-right min-w-[130px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Total Revenue
                            </span>
                        </th>
                        <th className="px-4 py-3 text-right min-w-[80px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Fees
                            </span>
                        </th>
                        <th className="px-4 py-3 text-right min-w-[100px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Amount
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[80px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA] whitespace-nowrap'>
                                Settlement Currency
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[150px] bg-[#FAFAFA]">
                            <span className="text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]">
                                Status
                            </span>
                        </th>
                        <th className='px-4 py-3 text-center bg-[#FAFAFA]'>
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Action
                            </span>
                        </th>
                    </tr>
                </thead>
                }
                {loading ? <Shimmer column={8}/> :
                    (<tbody>
                        {List?.data?.map((item, index) => (
                            <tr key={index} className="border-b-[1px] border-[#EEEEEE]">
                                <td 
                                    data-testid={`settlement-${index}`}
                                    className="px-4 py-3 whitespace-nowrap break-words sticky left-0 top-0 bg-white min-w-[125px]" 
                                    onClick={() => {
                                        if (hasViewSettlement) {
                                            navigate(`/settlements/${item._id}`)
                                        }
                                    }    
                                    }
                                >
                                    <p data-testid={`order-number-${index}`} class={`break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis underline ${hasViewSettlement ? 'cursor-pointer':'cursor-not-allowed'}`}>{item?.settlement_id}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-left">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis capitalize">{item?.merchant_name}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-left">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{item?.store_name || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-left">
                                    <p data-testid={`date-${index}`} class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis capitalize">{convertToDate(item?.cycle_start_date)}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-left">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{convertToDate(item?.cycle_end_date)}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-right">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{`${item?.currency?.symbol || '-'}${item?.total_amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-right">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis capitalize">{`${item?.currency?.symbol || '-'}${item?.settlement_fees?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '-'} `}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-right">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{`${item?.currency?.symbol || '-'}${item?.settlement_amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '-'} `}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-left">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{item?.currency?.code || '-'}</p>
                                </td>
                                <td className="flex justify-start gap-2 px-4 py-3 whitespace-nowrap break-words text-left">
                                    <img
                                        className='cursor-default'
                                        src={`/assets/images/${item.status}.svg`}
                                        alt={item.status} />
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B]">{item?.status || '-'}</p>
                                </td>
                                <td data-testid={`transaction-view-${index}`} className={`px-4 py-3 whitespace-nowrap break-words text-center ${hasViewSettlement ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                    onClick={() => {
                                        if (hasViewSettlement) {
                                            navigate(`/settlements/${item._id}`)
                                        }
                                    }
                                    }>
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] text-center">View</p>
                                </td>
                            </tr>
                        ))
                        }
                    </tbody>)}
            </table>
            {notFound && <div className='w-full flex justify-center'><EmptyPage text = "404 could not find what you are looking for."/></div>}
            {!notFound && error && (<div className='w-full flex justify-center'><EmptyPage text='No crypto settlements available yet' /></div>)}
            {List?.data?.length === 0 && !loading && !(param.attention || param.year || param.month) && (<div className='w-full flex justify-center'><EmptyPage text='No crypto settlements available yet' /></div>)}
            {List?.data?.length === 0 && !loading && (param.attention) && !(param.year || param.month) && (<div className='w-full flex justify-center'><EmptyPage text='No settlements require attention yet' /></div>)}
            {List?.data?.length === 0 && !loading && (param.year || param.month) && (<div className='w-full flex justify-center'><EmptyPage text='The filter combination has no results.' subtext='Please try different criteria.' /></div>)}
        </div>
    )
}
